import { ClassNameProps, Grid, StyleProps } from "@hex-insights/core";
import { SlimEmptyView } from "../../../../Components/Empty";
import { Student, StudentNameFragment } from "../../../../Utilities";
import { CardStudentMedicalCondition, StudentMedicalConditionCard } from "../Card";

export type StudentMedicalConditionStudentListSectionProps = {
	isLoading?: boolean;
	student: Pick<Student, "id"> & StudentNameFragment;
	studentMedicalConditions: CardStudentMedicalCondition[] | null | undefined;
	columns?: number;
} & Partial<ClassNameProps & StyleProps>;

export function StudentMedicalConditionStudentListSection({
	isLoading = false,
	studentMedicalConditions,
	columns = 1,
	className,
	style,
}: StudentMedicalConditionStudentListSectionProps) {
	if (isLoading && !studentMedicalConditions) {
		return (
			<SlimEmptyView className={className} style={style}>
				Loading...
			</SlimEmptyView>
		);
	}

	if (!studentMedicalConditions || studentMedicalConditions.length === 0) {
		return (
			<SlimEmptyView className={className} style={style}>
				No medical conditions listed
			</SlimEmptyView>
		);
	}

	return (
		<Grid
			tracks={columns}
			gap="var(--general--spaced---vertical-spacing) var(--general--spaced---horizontal-spacing)"
			className={className}
			style={style}
		>
			{studentMedicalConditions?.map((studentMedicalCondition) => (
				<StudentMedicalConditionCard
					key={studentMedicalCondition.id}
					studentMedicalCondition={studentMedicalCondition}
				/>
			))}
		</Grid>
	);
}
